import React from "react";

const statusColorMap = {
  primary: "#4D6BF6",
  created: "#949DAA",
  in_progress: "#F59E0B",
  completed: "#22c55e",
  delivered: "#22c55e",
  default: "#0d0d0d",
};

function Progress({
  text,
  completion = 0,
  onClick,
  type = "primary",
  classes = "",
  progressClasses = "",
  progressContainerClasses = "",
  textClasses = "",
  showPercent = true,
  hideProgress = false,
}) {
  const barColor = statusColorMap[type] || statusColorMap.default;
  return (
    <div
      style={{ display: "flex", flexDirection: "column", width: "100%", alignItems: "flex-start", justifyContent: "center", cursor: onClick ? "pointer" : "default" }}
      className={classes}
      onClick={onClick}
      role={onClick ? "button" : undefined}
    >
      {text && String(text).toLowerCase() !== "created" && (
        <div style={{ display: "flex", gap: 4, alignItems: "center", fontSize: "14px" }} className={textClasses}>
          <div
            style={{
              width: 12,
              height: 12,
              border: "2px solid",
              borderRadius: "50%",
              backgroundColor: barColor,
              borderColor: barColor,
            }}
          />
          {text}
        </div>
      )}
      {!hideProgress && completion >= 0 && (
        <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", width: "100%" }} className={progressContainerClasses}>
          <div style={{ position: "relative", minWidth: 80, flex: 1, height: 8, borderRadius: 4, backgroundColor: "#E5E7EB", overflow: "hidden" }}>
            <div
              style={{
                position: "absolute",
                left: 0,
                top: 0,
                height: "100%",
                width: `${Math.min(100, Math.max(0, completion))}%`,
                backgroundColor: completion === 100 ? "#22c55e" : barColor,
                borderRadius: 4,
                transition: "width 0.3s ease",
              }}
              className={progressClasses}
            />
          </div>
          {showPercent && <span style={{ fontSize: 12, marginLeft: 4 }}>{completion}%</span>}
        </div>
      )}
    </div>
  );
}

export default Progress;
